import React from "react";
import MartechMainComponent from "views/Components/Martech/Main/MartechMainComponent";

const MartechPage = ({ page }) => {
  return (
    <div style={mainDiv}>
      <MartechMainComponent page={page} />
    </div>
  );
};

export default MartechPage;

const mainDiv = {
  height: "100%",
  border: "0px solid black",
};
